<template>
	<div>
		<header>
			<h1 class="alpha heavy">Fact Find</h1>
		</header>
		<div>
			<div v-if="!formDataReady" class="section">
				<loader/>
			</div>
			<div v-else class="section">
				<the-fact-find-response-form
					:data="data"
					:form="form"
					:service="service"
					:structure="structure"
					@changed="changed"
					@formReady="formReady"
					@submit="submit"/>
			</div>
		</div>
	</div>
</template>
<script>
import TheFactFindResponseForm from "../fact-find/forms/TheFactFindResponseForm.vue";

export default {
	components: {
		TheFactFindResponseForm,
	},

	data() {
		return {
			formDataReady: false,
			form: {},
			saving: false,
			completing: false,
			structure: {},
			data: {},
			service: {},
		};
	},

	methods: {
		formReady(formStructure, formData) {
			// formStructure
			this.form = this.newForm(formStructure);
			this.changed(formData);
		},
		changed(data) {
			this.form.prefill(data);
		},
		async submit() {
			this.form.patch("leads/" + this.$route.params.lead + "/fact-find").then(response => {
				this.$store.dispatch("alertsStore/success", "Fact Find updated");
				this.$router.go(-1);
			});
		},
	},

	created() {
		http().get("leads/" + this.$route.params.lead + "/fact-find").then(response => {
			this.data = response.data.data || {};
			this.structure = response.data.structure;
			this.service = response.data.lead.service;
			this.form = this.newForm(this.structure);
			this.formDataReady = true;
		});
	},
};
</script>
